// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"ErrorPageMainSec_Wrapper__3En5K","SearchComponentWrapper":"ErrorPageMainSec_SearchComponentWrapper__2s1SE"};